/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";
import ReactDOM from "react-dom";
import { bem } from "../shared/BEM";
import { ConfigContext } from "./ConfigContext";
import { FormRepository } from "../shared/FormRepository";
import { DocumentManager } from "./lib/DocumentManager";
import { MenuSidebar } from "./components/Common/MenuSidebarComponent";
import { HashRouter, Switch, Route } from "react-router-dom";
import { PageForm } from "./components/Pages/PageFormComponent";
import { PageNewDocument } from "./components/Pages/PageNewDocument";
import { registerForms } from "../forms";

window.onload = () => {

	const formRepo = new FormRepository();
	const docMgr = new DocumentManager(formRepo);

	registerForms(formRepo);

	docMgr.restoreSession();

	ReactDOM.render(
		<ConfigContext.Provider value={{
			assetsPath: "/assets",
			mode: "browser"
		}}>
			<HashRouter>
				<div className={bem("app-main").str}>
					<MenuSidebar docMgr={docMgr} />
					<Switch>
						<Route path="/doc/:docId" render={
							(route) => <PageForm docMgr={docMgr} docId={route.match.params["docId"]} />
						} />
						<Route render={
							() => <PageNewDocument formRepo={formRepo} docMgr={docMgr} />
						} />
					</Switch>
				</div>
			</HashRouter>
		</ConfigContext.Provider>
		, document.getElementById("app-container"));

};
